import { theme } from "antd";

export const designerThemeLight = {
  token: {
    colorBgContainer: "#fff",
    borderRadius: 0,
  },
  components: {
    Layout: {
      headerBg: "#fff",
      headerPadding: "0 20px",
      headerHeight: 40,
    },
    Button: {
      defaultBg: "#f8f8f8",
      defaultHoverBg: "#16169d",
    },
    InputNumber: {
      borderRadius: 0,
      fontWeight: 600,
    },
    Collapse: {
      borderRadiusLG: 0,
      headerBg: "#fff",
      headerPadding: "6px 9px",
    },
    Card: {
      borderRadiusLG: 0,
      fontSize: "16px",
    },
  },
};

const legacyDarkComponents = {
  Layout: {
    headerBg: "#141416",
    headerPadding: "0 20px",
    headerHeight: 40,
  },
  Select: {
    colorBorder: "#525252",
    colorText: "#CDCDCD",
  },
  Button: {
    defaultBg: "#141416",
    defaultHoverBg: "#16169d",
    colorText: "#CDCDCD",
    defaultBorder: "#525252",
    primaryShadow: "none",
  },
  InputNumber: {
    borderRadius: 0,
    fontWeight: 600,
    colorBgContainer: "#141416",
    colorBorder: "#525252",
    colorText: "#CDCDCD",
  },
  Collapse: {
    borderRadiusLG: 0,
    headerBg: "#141416",
    contentBg: "#141416",
    headerPadding: "6px 9px",
    colorBorder: "#525252",
  },
  Card: {
    borderRadiusLG: 0,
    headerBg: "#141416",
    contentBg: "#141416",
    colorBorderSecondary: "#525252",
    colorText: "#CDCDCD",
    fontSize: "16px",
    headerFontSize: "16px",
  },
  Typography: {
    colorText: "#f4f4f4",
  },
  Form: {
    labelColor: "#f4f4f4",
  },
};

/**
 * SightFlight Theme Configuration
 * Single source of truth for Ant Design theme.
 * Used by both app.jsx (client) and ssr.jsx (server).
 */
export const sightFlightTheme = {
  algorithm: theme.darkAlgorithm,
  token: {
    // Brand Colors
    colorPrimary: "#E5E046",
    colorSuccess: "#22C55E",
    colorWarning: "#F59E0B",
    colorError: "#EF4444",
    colorInfo: "#3B82F6",

    // Background Colors
    colorBgBase: "#0F1419",
    colorBgContainer: "#1A2332",
    colorBgElevated: "#243447",
    colorBgLayout: "transparent",

    // Text Colors
    colorText: "#FFFFFF",
    colorTextSecondary: "#94A3B8",
    colorTextTertiary: "#64748B",

    // Border Colors
    colorBorder: "rgba(255, 255, 255, 0.2)",
    colorBorderSecondary: "rgba(255, 255, 255, 0.1)",

    // Font
    fontFamily:
      "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",

    borderRadius: 0,
    wireframe: false,
  },
  components: {
    ...legacyDarkComponents,
    Button: {
      ...legacyDarkComponents.Button,
      primaryColor: "#0F1419",
      colorPrimaryHover: "#D9D63E",
      defaultBorderColor: "rgba(255, 255, 255, 0.2)",
      defaultHoverBorderColor: "rgba(255, 255, 255, 0.3)",
    },
    Select: {
      ...legacyDarkComponents.Select,
      // Dropdown popup: dark surface + readable, on-brand option states
      // (mirrors the Menu tokens so every dropdown looks the same).
      colorBgElevated: "#1A2332",
      optionSelectedBg: "rgba(229, 224, 70, 0.15)",
      optionSelectedColor: "#E5E046",
      optionActiveBg: "rgba(255, 255, 255, 0.10)",
    },
    Menu: {
      colorBgContainer: "transparent",
      itemColor: "#94A3B8",
      itemHoverColor: "#FFFFFF",
      itemSelectedColor: "#E5E046",
      itemSelectedBg: "rgba(229, 224, 70, 0.15)",
      itemHoverBg: "rgba(255, 255, 255, 0.05)",
    },
    Checkbox: {
      colorPrimary: "#E5E046",
    },
    Tooltip: {
      colorBgSpotlight: "#2D3E50",
      colorTextLightSolid: "#FFFFFF",
    },
    Mentions: {
      colorBgElevated: "#1A2332",
      optionSelectedBg: "rgba(229, 224, 70, 0.15)",
      optionActiveBg: "rgba(255, 255, 255, 0.08)",
    },
  },
};

export const designerThemeDark = sightFlightTheme;

export const breakpoints = {
  xs: 480,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1600,
};
